!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@intentive/interactive-graphics"] = t() : e["@intentive/interactive-graphics"] = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    n.r(t);

    var r = function r(e, t) {
      var n = new URL(window.location),
          r = new URLSearchParams(n.search);
      null === t || 0 === t.length ? r.delete(e) : r.set(e, encodeURIComponent(t)), n.search = r.toString(), history.pushState({}, "", n.toString());
    },
        o = function o(e) {
      var t;
      Object.keys(e).forEach(function (n) {
        t = e[n], r(n, t);
      });
    },
        i = function i(e) {
      var t = e.initialState,
          n = e.ignoredKeys,
          r = Object.keys(t),
          i = new URL(window.location),
          u = new URLSearchParams(i.search),
          c = {},
          a = !0,
          f = !1,
          l = void 0;

      try {
        for (var d, s = u.entries()[Symbol.iterator](); !(a = (d = s.next()).done); a = !0) {
          var p = d.value,
              y = decodeURIComponent(p[0]);

          if ((!n || !n.includes(y)) && r.includes(y)) {
            var v = decodeURIComponent(p[1]);
            t[y] = v;
          }
        }
      } catch (e) {
        f = !0, l = e;
      } finally {
        try {
          a || null == s.return || s.return();
        } finally {
          if (f) throw l;
        }
      }

      return r.forEach(function (e) {
        n && n.includes(e) || (c[e] = t[e]);
      }), o(c), t;
    };

    n.d(t, "parseStateFromUrl", function () {
      return i;
    }), n.d(t, "updateQueryString", function () {
      return r;
    }), n.d(t, "updateQueryStringBatch", function () {
      return o;
    });
  }]);
});